// extracted by mini-css-extract-plugin
export var colorSquare = "_s8-0";
export var danger = "_s8-5";
export var lightPink = "_s8-8";
export var neutralBlue = "_s8-7";
export var neutralYellow = "_s8-6";
export var normal = "_s8-1";
export var primary = "_s8-2";
export var primaryLight = "_s8-3";
export var solidBlack = "_s8-g";
export var solidGreen = "_s8-b";
export var solidLightBlue = "_s8-d";
export var solidNavy = "_s8-c";
export var solidOrange = "_s8-f";
export var solidPink = "_s8-e";
export var solidRed = "_s8-9";
export var solidYellow = "_s8-a";
export var success = "_s8-4";